module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['VueLabel', _vm.isFile ? 'file' : '']
  }, [_c('label', {
    attrs: {
      "for": 'folder' + _vm.Key,
      "title": _vm.Name
    },
    on: {
      "click": function($event) {
        _vm.selectFile(_vm.Url)
      }
    }
  }, [_vm._v(_vm._s(_vm.Title))]), _vm._v(" "), (_vm.canEdit) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'מחיקה'
      }),
      expression: "{ html: 'מחיקה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons treeBtn",
    staticStyle: {
      "padding-left": "10px"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.confirm($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), (_vm.canEdit && _vm.isFolder) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:bottom",
      value: ({
        html: 'הוספה'
      }),
      expression: "{ html: 'הוספה' }",
      arg: "bottom"
    }],
    staticClass: "material-icons treeBtn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.showAddFile($event)
      }
    }
  }, [_vm._v("add")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4577d61a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FileFolderLabel.vue
// module id = 883
// module chunks = 2